function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#199be2",
  d: "M35.983,32.448l-3.536,3.536l7.87,7.87c0.195,0.195,0.512,0.195,0.707,0l2.828-2.828 c0.195-0.195,0.195-0.512,0-0.707L35.983,32.448z"
});

var _ref3 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "KGt2acGa95QyN2j07oBX6a",
  cx: 20.024,
  cy: 20.096,
  r: 19.604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.693,
  stopColor: "#006185"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.921,
  stopColor: "#35c1f1"
}));

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#KGt2acGa95QyN2j07oBX6a)",
  points: "31.601,28.065 28.065,31.601 32.448,35.983 35.983,32.448"
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "KGt2acGa95QyN2j07oBX6b",
  x1: 8.911,
  x2: 31.339,
  y1: 8.911,
  y2: 31.339,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a3ffff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.223,
  stopColor: "#9dfbff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#8bf1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.885,
  stopColor: "#6ee0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63daff"
}));

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 16,
  fill: "url(#KGt2acGa95QyN2j07oBX6b)"
});

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.9335cc5c.svg";
export { ForwardRef as ReactComponent };